/*
 * layout
 */
import { Link } from "@tanstack/react-router"
import { useDevMode } from "@timeprox/core/dev"
import { ErrorBoundary, Footer, Navbar } from "@timeprox/react/components"
import { getEnvDomainName, Title } from "@timeprox/utils/common"
import type { ReactNode } from "react"

type LayoutProps = {
	children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
	const { devMode } = useDevMode()

	return (
		<div className={"flex size-full flex-row"}>
			<div className={"flex size-full flex-col"}>
				<Navbar title={Title} titleHref={"/"} />
				<main
					className={
						"relative flex-1 transition-[width] overflow-y-hidden duration-300 ease-in-out"
					}
				>
					<ErrorBoundary>{children}</ErrorBoundary>
				</main>
				<Footer
					copyright={"© 2025 Timeprox"}
					copyrightHref={getEnvDomainName("https://timeprox.com")}
					devMode={devMode}
					RightSide={<div />}
				>
					<Link className={"text-inherit"} to={"/"}>
						Home
					</Link>
					<Link className={"text-inherit"} to={"/about"}>
						About
					</Link>
					{devMode && (
						<Link className={"text-inherit"} to={"/dev"}>
							Dev
						</Link>
					)}
				</Footer>
			</div>
		</div>
	)
}
